import type { ReferentialEnum } from "../../types"

export enum HealthMissionCategoryName {
  VACCINATION = "VACCINATION",
  SCREENING = "SCREENING",
  SUPPORT = "SUPPORT",
}

export const healthMissionCategoryEnum = {
  [HealthMissionCategoryName.VACCINATION]: { label: "Vaccination", rank: 0 },
  [HealthMissionCategoryName.SCREENING]: { label: "Dépistage", rank: 1 },
  [HealthMissionCategoryName.SUPPORT]: { label: "Accompagnement", rank: 2 },
} as const satisfies ReferentialEnum<{ rank: number }>

export enum HealthMissionMissionName {
  FLU = "FLU",
  COVID = "COVID",
  VACCINATION_SCHEDULE = "VACCINATION_SCHEDULE",
  COLORECTAL_CANCER_SCREENING = "COLORECTAL_CANCER_SCREENING",
  CYSTITIS_TROD = "CYSTITIS_TROD",
  SORE_THROAT_TROD = "SORE_THROAT_TROD",
  FLU_TROD = "FLU_TROD",
  SHARED_MEDICATION_REVIEW = "SHARED_MEDICATION_REVIEW",
  PREVENTION_ASSESSMENT = "PREVENTION_ASSESSMENT",
  PREGNANT_WOMEN_CONSULTATIONS = "PREGNANT_WOMEN_CONSULTATIONS",
  CHRONIC_DISEASE_CONSULTATIONS = "CHRONIC_DISEASE_CONSULTATIONS",
  AVK_AOD_ASTHMA_CONSULTATIONS = "AVK_AOD_ASTHMA_CONSULTATIONS",
  CANCER_CONSULTATIONS = "CANCER_CONSULTATIONS",
}

export const healthMissionMissionEnum = {
  [HealthMissionMissionName.FLU]: {
    label: "Grippe",
    category: HealthMissionCategoryName.VACCINATION,
    rankInCategory: 0,
  },
  [HealthMissionMissionName.COVID]: {
    label: "Covid",
    category: HealthMissionCategoryName.VACCINATION,
    rankInCategory: 1,
  },
  [HealthMissionMissionName.VACCINATION_SCHEDULE]: {
    label: "Calendrier vaccinal",
    category: HealthMissionCategoryName.VACCINATION,
    rankInCategory: 2,
  },
  [HealthMissionMissionName.COLORECTAL_CANCER_SCREENING]: {
    label: "Dépistage cancer colorectal",
    category: HealthMissionCategoryName.SCREENING,
    rankInCategory: 0,
  },
  [HealthMissionMissionName.CYSTITIS_TROD]: {
    label: "Trod Cystite",
    category: HealthMissionCategoryName.SCREENING,
    rankInCategory: 1,
  },
  [HealthMissionMissionName.SORE_THROAT_TROD]: {
    label: "Trod Angine",
    category: HealthMissionCategoryName.SCREENING,
    rankInCategory: 2,
  },
  [HealthMissionMissionName.FLU_TROD]: {
    label: "Trod Grippe",
    category: HealthMissionCategoryName.SCREENING,
    rankInCategory: 3,
  },
  [HealthMissionMissionName.SHARED_MEDICATION_REVIEW]: {
    label: "Bilan partagé de médication",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 0,
  },
  [HealthMissionMissionName.PREVENTION_ASSESSMENT]: {
    label: "Bilan de prévention",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 1,
  },
  [HealthMissionMissionName.PREGNANT_WOMEN_CONSULTATIONS]: {
    label: "Entretiens femme enceinte",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 2,
  },
  [HealthMissionMissionName.CHRONIC_DISEASE_CONSULTATIONS]: {
    label: "Entretiens antalgiques et opioïdes",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 3,
  },
  [HealthMissionMissionName.AVK_AOD_ASTHMA_CONSULTATIONS]: {
    label: "Entretiens AVK/AOD/Asthme",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 4,
  },
  [HealthMissionMissionName.CANCER_CONSULTATIONS]: {
    label: "Entretiens cancer",
    category: HealthMissionCategoryName.SUPPORT,
    rankInCategory: 5,
  },
} as const satisfies ReferentialEnum<{
  category: HealthMissionCategoryName
  rankInCategory: number
}>
